import List from 'containers/CareerRequests/List';
import Edit from 'containers/CareerRequests/Edit';
import Create from 'containers/CareerRequests/Create';
import Show from 'containers/CareerRequests/Show';

export default { List, Edit, Create, Show };
